import { render, staticRenderFns } from "./AProductForm.vue?vue&type=template&id=94abd3ec&"
import script from "./AProductForm.vue?vue&type=script&lang=js&"
export * from "./AProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports